export function VendorQuickAddCtrl (
  $scope,
  $translate,
  inheritorApi,
  messages,
  ukPostcodeApi
) {
  $scope.vendor  = {};

  inheritorApi.inheritCtrl('VendorQuickAddLiteCtrl', $scope);

  $scope.searchUKPostcode = function () {
    ukPostcodeApi.search($scope.vendor.postcode).then(data => {
      $scope.vendor.address1 = data.Premises;
      $scope.vendor.address2 = data.Street;
      $scope.vendor.postcode = data.Postcode;
      $scope.vendor.suburb   = data.PostTown;

      messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.SUPPLIER_ADDRESS'), 'success');
    }).catch(err => {
      messages.error(err);
    });
  };
}